<div class="classification" data-readiness-target="price-classification">
  <span class="classification__hint">
    Set per price to override the offering's values (Product attributes tab). A
    field left unset uses the offering's value.
  </span>

  <div class="classification__grid">
    @if (showNetworkType()) {
    <div
      class="classification__field"
      data-readiness-target="price-network-type"
    >
      <enr-select
        [size]="'large'"
        data-testid="price-network-type"
        [label]="isMyAis() ? 'Network Type *' : 'Network Type'"
        ariaLabel="Network Type"
        placeholder="Please select"
        [options]="networkTypeOptions()"
        [multiple]="true"
        [searchable]="true"
        [clearable]="true"
        [value]="networkType()"
        (valueChange)="onMultiChange('networkType', $event)"
      ></enr-select>
      @if (networkTypeHint(); as hint) {
      <p
        class="classification__inherited"
        data-testid="price-network-type-hint"
      >
        {{ hint }}
      </p>
      }
    </div>
    } @if (isMyAis()) {
    <div class="classification__field">
      <enr-select
        [size]="'large'"
        data-testid="price-package-type"
        [label]="'Package Type'"
        ariaLabel="Package Type"
        placeholder="Please select"
        [options]="packageTypeOptions"
        [clearable]="true"
        [value]="packageType()"
        (valueChange)="onPackageTypeChange($event)"
      ></enr-select>
      @if (packageTypeHint(); as hint) {
      <p
        class="classification__inherited"
        data-testid="price-package-type-hint"
      >
        {{ hint }}
      </p>
      }
    </div>
    }

    <div class="classification__field">
      <enr-select
        [size]="'large'"
        data-testid="price-segment"
        [label]="'Segment'"
        ariaLabel="Segment"
        placeholder="Please select"
        [options]="segmentOptions()"
        [multiple]="true"
        [searchable]="true"
        [clearable]="true"
        [value]="segment()"
        (valueChange)="onMultiChange('segment', $event)"
      ></enr-select>
      @if (segmentHint(); as hint) {
      <p class="classification__inherited" data-testid="price-segment-hint">
        {{ hint }}
      </p>
      }
    </div>

    @if (isMyAis()) {
    <div
      class="classification__field"
      data-readiness-target="price-effective-option"
    >
      <enr-select
        [size]="'large'"
        data-testid="price-effective-option"
        [label]="'Product effective option *'"
        ariaLabel="Product effective option"
        placeholder="Please select"
        [options]="effectiveOptions()"
        [multiple]="true"
        [searchable]="true"
        [clearable]="true"
        [value]="productEffectiveOption()"
        (valueChange)="onMultiChange('productEffectiveOption', $event)"
      ></enr-select>
      @if (effectiveHint(); as hint) {
      <p
        class="classification__inherited"
        data-testid="price-effective-option-hint"
      >
        {{ hint }}
      </p>
      }
    </div>
    }
  </div>
</div>
